import React from 'react';
import './Hero.css';

const Hero = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section id="hero" className="hero">
      <div className="hero-background">
        <div className="hero-gradient"></div>
        <div className="hero-shapes">
          <div className="shape shape-1"></div>
          <div className="shape shape-2"></div>
          <div className="shape shape-3"></div>
          <div className="shape shape-4"></div>
        </div>
      </div>
      <div className="hero-content">
        <div className="hero-logo-container">
          <div className="hero-logo">
            <div className="logo-grid">
              {[...Array(9)].map((_, i) => (
                <div key={i} className="logo-cell"></div>
              ))}
            </div>
          </div>
        </div>
        <h1 className="hero-title">Veltroz</h1>
        <p className="hero-tagline">VISION OF INNOVATORS</p>
        <p className="hero-description">
          Transforming ideas into innovative solutions that drive the future forward.
        </p>
        <div className="hero-buttons">
          <button className="btn btn-primary" onClick={() => scrollToSection('services')}>
            Our Services
          </button>
          <button className="btn btn-secondary" onClick={() => scrollToSection('contact')}>
            Get In Touch
          </button>
        </div>
      </div>
      <div className="hero-scroll-indicator">
        <div className="scroll-arrow"></div>
      </div>
    </section>
  );
};

export default Hero;

